export default __webpack_public_path__ + "static/media/pe.aeb36744.jpg";